import React, {Fragment} from 'react';

import {useAppointmentNotifications} from 'presentation/pages/private/hooks';
import {AppointmentsD0} from './AppointmentsD0';
import {AppointmentsDX} from './AppointmentsDX';
import {AppointmentsPastDue} from './AppointmentsPastDue';
import {AppointmentContentProps} from './types';

export function AppointmentContent({appointment}: AppointmentContentProps) {
	const {isToday, isPastDue} = useAppointmentNotifications({appointment});

	if (isPastDue) {
		return <AppointmentsPastDue appointment={appointment} />;
	}

	return (
		<Fragment>
			{isToday ? (
				<AppointmentsD0 appointment={appointment} />
			) : (
				<AppointmentsDX appointment={appointment} />
			)}
		</Fragment>
	);
}
